import { render } from "./ListeBonAncienPage.vue?vue&type=template&id=76da7815&ts=true"
import script from "./ListeBonAncienPage.vue?vue&type=script&lang=ts"
export * from "./ListeBonAncienPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__